import React, {useEffect, useRef, useState} from 'react';

import axios from 'axios';

import {Alert, Button, Card, Col, Form, Row, Table} from 'react-bootstrap';



const money = value => (Number(value) / 100).toLocaleString('pt-BR', {style:'currency', currency:'BRL'});

const date = () => {const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;};

const labels = {entradas_centavos:'Entradas líquidas de estornos', saidas_centavos:'Saídas líquidas de estornos', saldo_centavos:'Saldo dos movimentos', estornos_receita_centavos:'Estornos de receita no período', receber_aberto_centavos:'A receber — saldo atual', pagar_aberto_centavos:'A pagar — saldo atual'};



export default function HospitalarRevenueConsolidation({unitId, onOpenTitle}) {

  const [filters,setFilters]=useState(()=>({inicio:date().slice(0,7)+'-01',fim:date(),convenio_id:'',servico_id:''}));

  const [report,setReport]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),[reason,setReason]=useState('');

  const version=useRef(0);

  useEffect(()=>{version.current++;setReport(null);setError('');setBusy(false);return()=>{version.current++;};},[unitId]);

  const params=()=>Object.fromEntries(Object.entries(filters).filter(([,v])=>v!==''));

  const change=(key,value)=>{version.current++;setBusy(false);setFilters(f=>({...f,[key]:value}));setReport(null);};

  const load=async()=>{

    const request=++version.current;setBusy(true);setError('');setReport(null);

    try {const response=await axios.get('/api/hospitalar/financeiro/consolidado',{headers:{'X-Unit-Id':String(unitId)},params:params()});if(request===version.current)setReport(response.data);}

    catch(e){if(request===version.current)setError(e.response?.data?.message||'Não foi possível consolidar as fontes financeiras.');}

    finally {if(request===version.current)setBusy(false);}

  };

  const download=async format=>{

    const request=version.current;setBusy(true);setError('');

    try {

      const response=await axios.post('/api/hospitalar/financeiro/consolidado/exportar',{...params(),formato:format,motivo:reason},{headers:{'X-Unit-Id':String(unitId)},responseType:'blob'});

      if(request!==version.current)return;

      const url=URL.createObjectURL(response.data),a=document.createElement('a');a.href=url;a.download=`financeiro-consolidado.${format}`;a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);

    } catch(e){if(request===version.current)setError('Não foi possível exportar. Consulte novamente ou reduza o período.');}

    finally {if(request===version.current)setBusy(false);}

  };

  return <section className="py-3">

    <h5>Consolidação financeira e receita</h5>

    <p className="text-muted">Pagamentos legados e baixas de títulos na unidade ativa, com origem e estornos. Previsão e caixa aparecem separados.</p>

    <Row className="g-2 align-items-end">{[['inicio','Início','date'],['fim','Fim','date'],['convenio_id','Código do convênio','number'],['servico_id','Código do procedimento','number'],['prestador_id','Profissional da agenda','number'],['especialidade_id','Especialidade da agenda','number']].map(([key,label,type])=><Col xs={6} lg={3} key={key}><Form.Label htmlFor={`revenue-${key}`}>{label}</Form.Label><Form.Control id={`revenue-${key}`} type={type} min={type==='number'?1:undefined} value={filters[key]||''} onChange={e=>change(key,e.target.value)}/></Col>)}</Row>

    <Button className="mt-3" disabled={busy} onClick={load}>{busy?'Consolidando…':'Consultar consolidação'}</Button>

    {error&&<Alert variant="danger" className="mt-3">{error}</Alert>}

    {report&&<>

      {!report.completo&&<Alert variant="warning" className="mt-3">Há pendências de conciliação. Estes totais não representam todas as fontes integralmente conciliadas. Confira os valores e origens abaixo.</Alert>}

      <Row className="g-2 my-3">{Object.entries(report.totais).map(([key,value])=><Col xs={6} lg={4} key={key}><Card body className="h-100"><small>{labels[key]||key}</small><strong className="d-block fs-5">{money(value)}</strong></Card></Col>)}</Row>

      {report.comparativo&&<Alert variant="info">Programado por vencimento: <strong>{money(report.comparativo.programado_por_vencimento_centavos)}</strong> | Receita realizada no período: <strong>{money(report.comparativo.receita_realizada_centavos)}</strong> | Saldo atual a receber: <strong>{money(report.comparativo.saldo_atual_a_receber_centavos)}</strong>. As datas de vencimento e recebimento são bases distintas.</Alert>}

      <Row className="g-3">{[['por_periodo','Receita por período'],['por_convenio','Receita por convênio'],['por_procedimento','Receita por procedimento']].map(([key,title])=><Col lg={4} key={key}><Card body className="h-100"><h6>{title}</h6><Table responsive size="sm"><thead><tr><th>Grupo</th><th>Receita</th></tr></thead><tbody>{report[key].map(r=><tr key={r.id??r.grupo}><td>{['por_convenio','por_procedimento'].includes(key)&&Number(r.id)>0?<Button size="sm" variant="link" onClick={()=>change(key==='por_convenio'?'convenio_id':'servico_id',r.id)}>{r.grupo}</Button>:r.grupo}<div aria-label={`${r.grupo}: ${money(r.receita_centavos)}`} style={{height:5,borderRadius:3,marginTop:5,width:`${Math.abs(r.receita_centavos)/Math.max(1,...report[key].map(g=>Math.abs(g.receita_centavos)))*100}%`,background:r.receita_centavos<0?'#b02a37':'#198f96'}}/></td><td>{money(r.receita_centavos)}</td></tr>)}</tbody></Table>{report[key].length===0&&<p>Sem receita neste filtro.</p>}</Card></Col>)}</Row>

      <h6 className="mt-4">Detalhamento da origem dos movimentos</h6>

      <Table responsive striped size="sm"><thead><tr><th>Data</th><th>Origem</th><th>Título</th><th>Evento</th><th>Natureza</th><th>Convênio</th><th>Procedimento</th><th>Valor</th></tr></thead><tbody>{report.data.map(r=><tr key={`${r.chave}-${r.componente}`}><td>{r.data}</td><td>{r.fonte} #{r.origem_id}<small className="d-block">{r.descricao}</small></td><td>{r.titulo_id&&onOpenTitle?<Button variant="link" size="sm" onClick={()=>onOpenTitle(r.titulo_id)}>#{r.titulo_id}</Button>:r.titulo_id||'—'}</td><td>{r.evento}</td><td>{r.natureza}</td><td>{r.convenio}</td><td>{r.procedimento}</td><td>{money(r.valor_centavos)}</td></tr>)}</tbody></Table>

      {!report.data.length&&<p>Sem movimentos confirmados para o período.</p>}

      <details className="my-3"><summary>Saldo atual por vencimento — não somar ao caixa ({report.previsao.length})</summary><Table responsive size="sm"><thead><tr><th>Título / parcela</th><th>Vencimento</th><th>Natureza</th><th>Procedimento</th><th>Saldo</th></tr></thead><tbody>{report.previsao.map((r,i)=><tr key={`${r.parcela_id}-${i}`}><td>#{r.titulo_id} / {r.parcela_id}</td><td>{r.vencimento}</td><td>{r.natureza}</td><td>{r.procedimento}</td><td>{money(r.valor_centavos)}</td></tr>)}</tbody></Table></details>

      <details className="my-3" open={report.pendencias.length>0}><summary>Pendências de conciliação ({report.pendencias.length})</summary>{report.pendencias.map((p,i)=><Alert key={i} variant="warning">{p.fonte} {p.origem_id?`#${p.origem_id}`:''}: {p.motivo} {p.valor_centavos!==null&&money(p.valor_centavos)}</Alert>)}</details>

      <details className="my-3"><summary>Origens substituídas por título — sem dupla contagem ({report.origens_substituidas.length})</summary>{report.origens_substituidas.map(r=><p key={`${r.fonte}-${r.origem_id}`}>{r.fonte} #{r.origem_id} → título #{r.titulo_id}. {r.motivo}</p>)}</details>

      <details className="my-3"><summary>Critérios e limites da consolidação</summary><ul>{report.criterios.map(text=><li key={text}>{text}</li>)}</ul><p>Consulta UTC: {report.consultado_em}</p></details>

      <Form.Label htmlFor="revenue-export-reason">Finalidade da exportação consolidada</Form.Label><Form.Control id="revenue-export-reason" value={reason} onChange={e=>setReason(e.target.value)}/><div className="d-flex gap-2 mt-2">{['xlsx','pdf'].map(format=><Button key={format} variant="outline-primary" disabled={busy||reason.trim().length<5} onClick={()=>download(format)}>Exportar {format.toUpperCase()}</Button>)}</div>

    </>}

  </section>;

}

